import gsap from "gsap";
import { ScrollTrigger, DrawSVGPlugin } from "gsap/all";

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

const lines = document.querySelectorAll(".line");

const init = () => {
    gsap.from(lines, {
        drawSVG: 0,
        ease: "none",
        scrollTrigger: {
            start: "top+=100vh top+=100vh",
            end: "bottom-=500 top",
            scrub: true,
        }
    });
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});